module.exports = __webpack_public_path__ + "static/media/sem_foto.83b57be3.png";